/**
 * The fit padding and the size of the surface a fit or a focus box measures:
 * shared by the focus surface, presentation boxes and the old canvas.
 */

/** The single padding ratio for ALL fit operations (spec: 30% margin). */
export const FIT_PADDING_RATIO = 0.3;

export interface CanvasViewportDimensions {
  viewportWidth: number;
  viewportHeight: number;
}

/** The element's size, else the canvas viewport's, else the window's. */
export function getCanvasViewportDimensions(
  element?: Element | null,
): CanvasViewportDimensions {
  const target =
    element ??
    (typeof document !== "undefined"
      ? document.querySelector("[data-canvas-viewport]")
      : null);
  const rect = target?.getBoundingClientRect();
  return {
    viewportWidth:
      rect && rect.width > 0
        ? rect.width
        : typeof window !== "undefined"
          ? window.innerWidth
          : 1,
    viewportHeight:
      rect && rect.height > 0
        ? rect.height
        : typeof window !== "undefined"
          ? window.innerHeight
          : 1,
  };
}
